export const CHART_VIEWPORT_RESTORE_MIN_SOURCE_CANDLES = 20;

export function clampChartLogicalRange(range, totalBars) {
  if (!range || totalBars <= 0) return null;

  const rawFrom = Number(range.from);
  const rawTo = Number(range.to);
  if (!Number.isFinite(rawFrom) || !Number.isFinite(rawTo)) {
    return null;
  }

  const minSpan = totalBars > 1 ? Math.min(10, totalBars - 1) : 1;
  const maxSpan = Math.max(minSpan, totalBars + 1);
  const minFrom = -0.5;
  const maxTo = totalBars - 0.5;

  let span = rawTo - rawFrom;
  if (!Number.isFinite(span) || span <= 0) {
    span = minSpan;
  }
  span = Math.min(Math.max(span, minSpan), maxSpan);

  const center = (rawFrom + rawTo) / 2;
  let from = center - span / 2;
  let to = center + span / 2;

  if (from < minFrom) {
    to += minFrom - from;
    from = minFrom;
  }

  if (to > maxTo) {
    from -= to - maxTo;
    to = maxTo;
  }

  return {
    from: Math.max(from, minFrom),
    to: Math.min(to, maxTo),
  };
}

export function getChartViewportAction({
  viewportMode = "reset",
  previousViewKey = null,
  nextViewKey = null,
  initialLoaded = false,
  shouldResetViewport = true,
  sourceCandleCount = 0,
  minSourceCandles = CHART_VIEWPORT_RESTORE_MIN_SOURCE_CANDLES,
  logicalRange = null,
  totalBars = 0,
} = {}) {
  const canPreserveViewport =
    viewportMode === "smart-preserve" &&
    previousViewKey === nextViewKey &&
    initialLoaded &&
    !shouldResetViewport &&
    sourceCandleCount >= minSourceCandles;

  if (!canPreserveViewport) {
    return { type: "reset", logicalRange: null };
  }

  const nextLogicalRange = clampChartLogicalRange(logicalRange, totalBars);
  if (!nextLogicalRange) {
    return { type: "reset", logicalRange: null };
  }

  return {
    type: "preserve",
    logicalRange: nextLogicalRange,
  };
}
